import React, { useState, useEffect } from 'react'
import { Typography, Box, Divider, Button, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Paper, Stack } from "@mui/material"
import { useNavigate } from 'react-router-dom'
import parse from "html-react-parser";
import axios from "axios"


export default function AnnouncementList() {

    const navigate = useNavigate()

    const [announcementData, setAnnouncementData] = useState([])

    const getAllAnnouncement = async () => {

        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}getAllAnnouncement`)
            console.log(response?.data?.data);
            setAnnouncementData(response?.data?.data)
        } catch (error) {
            console.log(error);
        }
    }

    useEffect(() => {
        getAllAnnouncement()
    }, [])


    return (
        <>
            <Stack direction="row" justifyContent="space-between">
                <Typography variant="h7_1">Announcement</Typography>
                <Button onClick={() => navigate("AnnouncementAdd")} variant="contained">Add</Button>
            </Stack>
            <Divider sx={{ mb: 3, mt: 2 }} />
            <TableContainer sx={{ borderRadius: "8px", }}>
                <Table sx={{ minWidth: 650, }} aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell>
                                <Typography variant="h9_1" color='#333333'>Title</Typography>
                            </TableCell>
                            <TableCell> <Typography variant="h9_1" color='#333333'>SubTitle</Typography></TableCell>
                            <TableCell> <Typography variant="h9_1" color='#333333'>Date</Typography></TableCell>
                            <TableCell> <Typography variant="h9_1" color='#333333'>Time</Typography></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {announcementData.map((item, index) => (
                            <TableRow key={item.name} sx={{ borderTop: ".5px solid #737373" }} >
                                <TableCell ><Typography variant="h9_4" color='#333333'>{item?.title || "-"}</Typography></TableCell>
                                <TableCell ><Typography variant="h9_4" color='#333333'>{item?.subtitle || "_"}</Typography></TableCell>
                                <TableCell ><Typography variant="h9_4" color='#333333'>{item?.date || "-"}</Typography></TableCell>
                                <TableCell ><Typography variant="h9_4" color='#333333'>{item?.time || "-"}</Typography></TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </>
    )
}
